import React from 'react'
import { Route, Switch } from 'react-router-dom'
import load from 'components/LoadableComponent'
import { RouteNotFound } from 'views/Error/PageNotFound'


const BaseView = load(() =>
  import('views/Public/Others/BaseView'))



export const descriptors = {
  others:            `/others/`,
}


export default <Switch>
  <Route exact path={ descriptors.others } component={ BaseView } />
  <RouteNotFound />
</Switch>
